import React from "react";
import getLoadingState from "~/conclude/loading";
import { QrScanner } from "~/components/QrScanner/QrScanner";
import { connect } from "~/redux/connect";

const QrScannerFactory = () => {
    return class RxQrScanner extends React.PureComponent {
        render() {
            return <QrScanner loading={this.props.loading } show onScan={ this.props.onScan } />
        }
    }
}

const mapStateToProps = (state, {modelId}) => {
    return {
        loading: getLoadingState(
            state,
            { loading: ['actionLoading'], modelId }
        ).loading,
    }
}

const RxQrScanner = connect(mapStateToProps)(QrScannerFactory());

export { RxQrScanner as QrScanner }